import { DocsBlockBuilder } from "../../../../../../tools/docs-block-builder/SDKDocsBlockBuilder";
import { DocsBlockCategory } from "../../../../../enums/SDKDocsBlockCategory";
import { id, name, icon, descriptionShort, searchKeywords, helpText, docsUrl, } from "../embed/SDKDocsBlockActualEmbed";
const b = new DocsBlockBuilder();
/**
 * 2. Block properties
 */
const properties = {
    embedUrl: b.embedUrlProperty({
        id: "embedUrl",
        name: "Embed URL",
        options: {
            allowCaption: true,
            allowResize: true,
            defaultHeight: 400,
            isInteractive: true,
            urlValidationRegex: "^(https?://)?(www.)?.+$",
        },
    }),
};
/**
 * 3. Block variants
 */
const defaultVariant = b.defaultVariantUsingDefaultLayout({
    properties: [properties.embedUrl],
});
/**
 * 4. Block item
 */
const blockItem = b.singleVariantItem({
    properties: [properties.embedUrl],
    variant: defaultVariant,
});
/**
 * 5. Block definition
 */
const block = b.singleItemBlock({
    id,
    name,
    icon,
    category: DocsBlockCategory.media,
    description: descriptionShort,
    item: blockItem,
    searchKeywords,
    onboarding: b.onboarding({
        helpText,
        documentationLink: docsUrl,
    }),
});
/** 6. Block export */
export { block as Embed };
